// extracted by css-extract-rspack-plugin
export default {"modal":"oo0fhm_Cxy80RUSo","header":"hplSJnwYf3OpIN6z","close":"pDN41X3QYLndj7KW","content":"uE4ZjMEF1JUfGJml"};